module.exports = __webpack_public_path__ + "static/young-leader-photo-jimena_quadrana-594991b4fb7cae337dea6bfb945605ce.jpg";